
import React from 'react';
import { DisplaySlide } from '../layout/DisplaySlide';
import { ContentSection } from '../layout/ContentSection';
import { ScrollingText } from '../layout/ScrollingText';
import { AdaptiveText } from '../layout/AdaptiveText';

interface Announcement {
  title: string;
  content: string;
  priority?: 'high' | 'medium' | 'low';
}

interface AnnouncementSlideProps {
  announcements: Announcement[];
  title?: string;
}

export const AnnouncementSlide: React.FC<AnnouncementSlideProps> = ({
  announcements,
  title = "הודעות"
}) => {
  return (
    <DisplaySlide background="subtle" padding="md">
      <div className="h-full flex flex-col space-y-6">
        {/* Slide Title */}
        <div className="text-center">
          <AdaptiveText baseSize="xl" className="font-frank font-bold text-white text-shadow-lg">
            {title}
          </AdaptiveText>
        </div>

        {/* Announcements */}
        <div className="flex-1 space-y-4 overflow-hidden">
          {announcements.slice(0, 3).map((announcement, index) => (
            <ContentSection
              key={index}
              title={announcement.title}
              height="flex"
              textSize="md"
              className={
                announcement.priority === 'high' 
                  ? "border-red-300/50 bg-red-100/10" 
                  : announcement.priority === 'medium'
                  ? "border-yellow-300/50 bg-yellow-100/10"
                  : ""
              }
            >
              <ScrollingText
                text={announcement.content}
                maxLines={4}
                scrollInterval={5000}
              />
            </ContentSection>
          ))}
        </div>
      </div>
    </DisplaySlide>
  );
};
